import { ArslActionRemoveColumn, ArsListingState } from "../interface";
import { datasetsFromColumns } from "./datasetsFromColumns";

/**
 * Removes a listing column when more than one column remains.
 *
 * @param state - Current ARS listing state
 * @param action - Remove-column action identifying the target column
 * @returns Updated ARS listing state, or the original state when removal is not allowed
 */
export const arsl_removeColumn = <T>(
  state: ArsListingState<T>,
  action: ArslActionRemoveColumn,
): ArsListingState<T> => {
  if (state.bodyData.arsListingColumns.length <= 1) return state;

  const newState = {
    ...state,
    changed: true,
    bodyData: {
      ...state.bodyData,
      arsListingColumns: state.bodyData.arsListingColumns.filter(
        (column) => column.id !== action.colId,
      ),
    },
  };

  // Refresh datasets list
  newState.datasets = datasetsFromColumns(newState.bodyData.arsListingColumns);

  return newState;
};
